import { emptySplitApi as api } from "../../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1AssessmentsPlansGoalsList: build.query<
      ApiPortalV1AssessmentsPlansGoalsListApiResponse,
      ApiPortalV1AssessmentsPlansGoalsListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/goals/`,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
        },
      }),
    }),
    apiPortalV1AssessmentsPlansGoalsCreate: build.mutation<
      ApiPortalV1AssessmentsPlansGoalsCreateApiResponse,
      ApiPortalV1AssessmentsPlansGoalsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/goals/`,
        method: "POST",
        body: queryArg.assessmentPeriodActionPlanGoal,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
          debrief_schedule_id: queryArg.debriefScheduleId,
        },
      }),
    }),
    apiPortalV1AssessmentsPlansGoalsRetrieve: build.query<
      ApiPortalV1AssessmentsPlansGoalsRetrieveApiResponse,
      ApiPortalV1AssessmentsPlansGoalsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/goals/${queryArg.id}/`,
      }),
    }),
    apiPortalV1AssessmentsPlansGoalsUpdate: build.mutation<
      ApiPortalV1AssessmentsPlansGoalsUpdateApiResponse,
      ApiPortalV1AssessmentsPlansGoalsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/goals/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.assessmentPeriodActionPlanGoal,
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
          debrief_schedule_id: queryArg.debriefScheduleId,
        },
      }),
    }),
    apiPortalV1AssessmentsPlansGoalsPartialUpdate: build.mutation<
      ApiPortalV1AssessmentsPlansGoalsPartialUpdateApiResponse,
      ApiPortalV1AssessmentsPlansGoalsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/goals/${queryArg.id}/`,
        method: "PATCH",
        body: queryArg.patchedAssessmentPeriodActionPlanGoal,
      }),
    }),
    apiPortalV1AssessmentsPlansGoalsDestroy: build.mutation<
      ApiPortalV1AssessmentsPlansGoalsDestroyApiResponse,
      ApiPortalV1AssessmentsPlansGoalsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/assessments/plans/goals/${queryArg.id}/`,
        method: "DELETE",
        params: {
          assessment_period_id: queryArg.assessmentPeriodId,
          debrief_schedule_id: queryArg.debriefScheduleId,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1AssessmentsPlansGoalsListApiResponse =
  /** status 200  */ AssessmentPeriodActionPlanGoalRead[];
export type ApiPortalV1AssessmentsPlansGoalsListApiArg = {
  assessmentPeriodId: number;
};
export type ApiPortalV1AssessmentsPlansGoalsCreateApiResponse =
  /** status 201  */ AssessmentPeriodActionPlanGoalRead;
export type ApiPortalV1AssessmentsPlansGoalsCreateApiArg = {
  assessmentPeriodId: number;
  debriefScheduleId?: number;
  assessmentPeriodActionPlanGoal: AssessmentPeriodActionPlanGoal;
};
export type ApiPortalV1AssessmentsPlansGoalsRetrieveApiResponse =
  /** status 200  */ AssessmentPeriodActionPlanGoalRead;
export type ApiPortalV1AssessmentsPlansGoalsRetrieveApiArg = {
  /** A unique integer value identifying this organization assessment period action plan goal. */
  id: number;
};
export type ApiPortalV1AssessmentsPlansGoalsUpdateApiResponse =
  /** status 200  */ AssessmentPeriodActionPlanGoalRead;
export type ApiPortalV1AssessmentsPlansGoalsUpdateApiArg = {
  assessmentPeriodId: number;
  debriefScheduleId?: number;
  /** A unique integer value identifying this organization assessment period action plan goal. */
  id: number;
  assessmentPeriodActionPlanGoal: AssessmentPeriodActionPlanGoal;
};
export type ApiPortalV1AssessmentsPlansGoalsPartialUpdateApiResponse =
  /** status 200  */ AssessmentPeriodActionPlanGoalRead;
export type ApiPortalV1AssessmentsPlansGoalsPartialUpdateApiArg = {
  /** A unique integer value identifying this organization assessment period action plan goal. */
  id: number;
  patchedAssessmentPeriodActionPlanGoal: PatchedAssessmentPeriodActionPlanGoal;
};
export type ApiPortalV1AssessmentsPlansGoalsDestroyApiResponse = unknown;
export type ApiPortalV1AssessmentsPlansGoalsDestroyApiArg = {
  assessmentPeriodId: number;
  debriefScheduleId?: number;
  /** A unique integer value identifying this organization assessment period action plan goal. */
  id: number;
};
export type AssessmentPeriodActionPlanGoal = {
  description: string;
  pillar_name?: string;
};
export type AssessmentPeriodActionPlanGoalRead = {
  id: number;
  description: string;
  pillar_name?: string;
};
export type PatchedAssessmentPeriodActionPlanGoal = {
  description?: string;
  pillar_name?: string;
};
export type PatchedAssessmentPeriodActionPlanGoalRead = {
  id?: number;
  description?: string;
  pillar_name?: string;
};
export const {
  useApiPortalV1AssessmentsPlansGoalsListQuery,
  useApiPortalV1AssessmentsPlansGoalsCreateMutation,
  useApiPortalV1AssessmentsPlansGoalsRetrieveQuery,
  useApiPortalV1AssessmentsPlansGoalsUpdateMutation,
  useApiPortalV1AssessmentsPlansGoalsPartialUpdateMutation,
  useApiPortalV1AssessmentsPlansGoalsDestroyMutation,
} = injectedRtkApi;
